<div ng-controller="globalNotificationController as noticeCtrl" class="modal-view ">
    <c-auto-form config="noticeCtrl.autoFormConfig"></c-auto-form>
</div>